import assets from "app/assets";
import config from "config";
import gsap from "gsap";
import { Container, NineSlicePlane, TextStyle, Text, DEG_TO_RAD, Sprite, Texture, BaseTexture } from "pixi.js";
import tools from "tools";
import HomeBtn from "../home/homeBtn";
const WIDTH = 400;
const HEIGHT = 300;
export default class BoosterRvPopin extends Container {
  constructor() {
    super();
    tools.autobind(this);
    this._init();
    this._initEvents();
  }
  _init() {
    this.bg = new NineSlicePlane(assets.textures.popupBoosterBg.texture, 34, 36, 34, 51);
    this.bg.width = WIDTH;
    this.bg.height = HEIGHT;
    this.bg.x = -WIDTH / 2;
    this.bg.y = -HEIGHT / 2;
    this.addChild(this.bg);
    this.close = new Sprite(assets.textures.popupBoosterClose.texture);
    this.close.anchor.set(.5);
    this.close.scale.set(.5);
    this.close.position.set(WIDTH / 2 - 38, -HEIGHT / 2 + 38);
    this.addChild(this.close);
    const titleStyle = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: 30,
      fill: ['#feecb4', '#ffba32'],
      stroke: '#0b2944',
      strokeThickness: 2,
      dropShadow: true,
      dropShadowAlpha: 1,
      dropShadowAngle: DEG_TO_RAD * 90,
      dropShadowBlur: 1,
      dropShadowColor: '0x0b2944',
      dropShadowDistance: 2,
      wordWrap: true,
      wordWrapWidth: 248,
      lineHeight: 30
    });
    this.title = new Text(assets.local.boosterRvTitle, titleStyle);
    this.title.x = -120;
    this.title.y = -135;
    this.addChild(this.title);
    this.rv = new HomeBtn(assets.textures.brv.texture, "+100   ");
    this.rv.scale.set(1.3);
    this.rv.x = 0;
    this.rv.y = -60;
    this.rv.click = () => {
      config.popin.singleRequestRewarded(() => {
        gsap.delayedCall(.5, () => {
          this.hide();
          config.level.updateCoins(100);
          config.boosterRvConsumed = true;
        });
      });
    };
    this.addChild(this.rv);
    this.coins = new Sprite(assets.textures.coins.texture);
    this.coins.scale.set(1);
    this.coins.anchor.set(-1, .5);
    this.rv._text.addChild(this.coins);
    this.scale.set(0);
    this.visible = false;
    this._isDown = false;
  }
  _initEvents() {
    this.interactive = true;
    this.close.interactive = true;
    this.close.buttonMode = true;
    this.close.on('pointerdown', this._onDown);
    this.close.on('pointerup', this._onUp);
    this.close.on('pointerupoutside', this._onOut);
  }
  _onDown() {
    if (this._isDown) {
      return;
    }
    this._isDown = true;
    this.tween = gsap.to(this.close.scale, {
      duration: .2,
      x: .43,
      y: .43
    });
  }
  _onUp() {
    if (!this._isDown) {
      return;
    }
    this._isDown = false;
    this.tween && this.tween.kill();
    this.tween = gsap.to(this.close.scale, {
      duration: .2,
      x: .5,
      y: .5
    });
    this.hide();
  }
  _onOut() {
    this._isDown = false;
    this.tween && this.tween.kill();
    this.tween = gsap.to(this.close.scale, {
      duration: .2,
      x: .5,
      y: .5
    });
  }
  show() {
    this.scale.set(.2);
    this.visible = true;
    gsap.to(this.scale, {
      duration: .4,
      x: 1,
      y: 1,
      ease: "back.out(1)"
    });
  }
  hide() {
    if (!this.visible) {
      return;
    }
    config.touchAccess = true;
    gsap.to(this.scale, {
      duration: .3,
      x: 0,
      y: 0,
      onComplete: () => {
        this.visible = false;
      }
    });
  }
}
